import React from "react";
import HomePageV2 from "./HomePageV2";

const HomePageV2Page = () => {
  return <HomePageV2 />;
};

export default HomePageV2Page;
